<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ServiceAdditionalOptionsMixin extends Vue {
        additionalOptions = {}
        additionalOptionsLoading = false
        extraServices = []
        earlyCheckInSelected = null
        lateCheckOutSelected = null

        async loadAdditionalOptions({serviceType, processId}) {
            try {
                this.additionalOptionsLoading = true

                this.earlyCheckInSelected = null
                this.lateCheckOutSelected = null

                const additionalOptionsFnName = (() => {
                    switch (serviceType) {
                        case 'ACCOMMODATION':
                            return 'additionalOptions'
                        case 'FLIGHT':
                        case 'OWNCHARTER':
                            return 'additionalFlightOptions'
                        case 'ACTIVITY':
                            return 'activityAdditionalOptions'
                        case 'CARRENT':
                            return 'additionalCarRentOptions'
                        case 'TRANSFER':
                            return 'transferAdditionalOptions'
                        case 'CRUISE':
                            return 'cruiseAdditionalOptions'
                        case 'OWNEXTRASERVICE':
                            return 'ownExtraServiceAdditionalOptions'
                    }
                })()
                this.additionalOptions = await this.$api[additionalOptionsFnName].get({processId})
                if (this.additionalOptions?.extraServices?.length) {
                    this.extraServices = this.additionalOptions.extraServices.reduce(
                        (extraServices, {serviceRPH, id: additionalOptionsExtraServiceId}) => {
                            const extraService = this.manualModification
                                ? this.service.extraServices.find(({id}) => +additionalOptionsExtraServiceId === id)
                                : this.service.extraServices.find(({id}) => +serviceRPH === id)

                            if (extraService) {
                                extraServices.push(this.mapExtraServiceData(extraService))
                            }
                            return extraServices
                        },
                        []
                    )
                }
            } catch (e) {
                this.additionalOptions = {}
                this.extraServices = []
            } finally {
                this.additionalOptionsLoading = false
            }
        }

        getCheckInOutSelectOptions(optionKey) {
            if (this.additionalOptions?.[optionKey]) {
                return this.additionalOptions[optionKey].map(opt => {
                    return {
                        ...opt,
                        name: `${opt.time} (+${this.$filters.price(opt.price)})`,
                    }
                })
            }
            return null
        }

        updateEarlyCheckInOut({value, type}) {
            const data = this[`${type}Items`]?.find(el => el.time === value)
            if (!data) {
                this[`${type}Selected`] = null
                return
            }

            this[`${type}Selected`] = {
                type,
                ...data,
            }
        }

        get earlyCheckInItems() {
            return this.getCheckInOutSelectOptions('earlyCheckIn')
        }

        get lateCheckOutItems() {
            return this.getCheckInOutSelectOptions('lateCheckOut')
        }

        mapExtraServiceData({id, quantity}) {
            return {serviceRPH: id.toString(), quantity}
        }
    }

    export default ServiceAdditionalOptionsMixin
</script>
